import React from 'react';

const SvgMu = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MU_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MU_svg__b" fill="#fff">
        <use xlinkHref="#MU_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MU_svg__a" />
      <path fill="#1DBB63" mask="url(#MU_svg__b)" d="M0 16h28v4H0z" />
      <path fill="#222B82" mask="url(#MU_svg__b)" d="M0 5.333h28v5.333H0z" />
      <path fill="#FFD741" mask="url(#MU_svg__b)" d="M0 10.667h28V16H0z" />
      <path fill="#F4374A" mask="url(#MU_svg__b)" d="M0 0h28v5.333H0z" />
    </g>
  </svg>
);

export default SvgMu;
